/*globals $ */

class Hero {
  constructor(pageApp) {
    this.pageApp = pageApp;
    this.$container = $(".Hero");
    this.$video = $("#video_hero");
    this.onLoadCompleteVideo = false;
    this.onCompleteResize = false;
    this.initialInnerHeight = window.innerHeight;
    this.isFixedHeight = false;
    this.mediaQuery1000 = window.matchMedia("(max-width: 1000px)");
    this.mediaQuery = window.matchMedia("(max-width: 800px)");

    let onLoadData = () => {
      if (!this.onLoadCompleteVideo) {
        this.onLoadCompleteVideo = true;
        /*
        setTimeout(() => {
          this.pageApp.onLoadCompleteHero();
        }, 1000);
        */

        $(".HeroNav").css({
          right: parseInt(
            $(window).width() -
              ($(".Menu").offset()["left"] + $(".Menu").width())
          ),
        });

        if (this.onCompleteResize) {
          this.start();
        } else {
          this.loadCompleteInterval = setInterval(() => {
            if (this.onCompleteResize) {
              clearInterval(this.loadCompleteInterval);
              this.start();
            }
          }, 1000 / 30);
        }
      }
    };

    this.$video[0].onloadeddata = () => {
      onLoadData();
    };

    this.errorInterval = setTimeout(() => {
      if (!this.onLoadCompleteVideo) {
        onLoadData();
      }
      clearTimeout(this.errorInterval);
    }, 3000);
  }

  destroy() {
    clearTimeout(this.errorInterval);
  }
  start() {
    if (this.initialInnerHeight > window.innerHeight && !this.isFixedHeight) {
      this.isFixedHeight = true;
      this.initialInnerHeight = window.innerHeight;
    }
    if (this.mediaQuery1000.matches) {
      this.$container.css(
        "height",
        this.initialInnerHeight + $(".HeroNav__sp-position").height()
      );
      $(".HeroTitle").css("top", parseInt(this.initialInnerHeight / 2));
    } else {
      this.$container.css("height", "100vh");
      $(".HeroTitle").css("top", "50%");
    }

    if (this.mediaQuery.matches) {
      $(".HeroNav").css({ right: "auto" });
    } else {
      $(".HeroNav").css({
        right: parseInt(
          $(window).width() - ($(".Menu").offset()["left"] + $(".Menu").width())
        ),
      });
    }

    $(".HeroBg").addClass("HeroBg--start");
    $(".HeroTitleBg").addClass("HeroTitleBg--start");
    setTimeout(() => {
      $(".HeroTitleBg").addClass("HeroTitleBg--whiteout");
    }, 4000);
  }

  onWindowResize() {
    if (this.mediaQuery1000.matches) {
      this.$container.css(
        "height",
        this.initialInnerHeight + $(".HeroNav__sp-position").height()
      );
    } else {
      this.$container.css("height", "100vh");
    }

    let viewWidth = this.$container.width();
    let viewHeight = this.$container.height();
    let viewRatio = viewWidth / viewHeight;
    let videoRatio = 16 / 9;
    let videoTop = 0;
    let videoLeft = 0;

    if (viewRatio < videoRatio) {
      this.videoHeight = viewHeight;
      this.videoWidth = this.videoHeight * videoRatio;
      videoTop = 0;
      videoLeft = -parseInt((this.videoWidth - viewWidth) / 2);
    } else {
      this.videoWidth = viewWidth;
      this.videoHeight = this.videoWidth / videoRatio;
      videoLeft = 0;
      videoTop = -parseInt((this.videoHeight - viewHeight) / 2);
    }

    this.$video.css({
      width: this.videoWidth,
      height: this.videoHeight,
      top: videoTop,
      left: videoLeft,
    });
    this.onCompleteResize = true;

    if (this.mediaQuery.matches) {
      $(".HeroNav").css({ right: "auto" });
    } else {
      $(".HeroNav").css({
        right: parseInt(
          $(window).width() - ($(".Menu").offset()["left"] + $(".Menu").width())
        ),
      });
    }

    // this.hero.onWindowResize();
    /*
    let viewWidth = window.innerWidth;
    let baseHeight = parseInt(window.innerHeight * 1);

    if(viewWidth / window.innerHeight > 1.5) {
      baseHeight = parseInt(window.innerHeight * 1.15);
    }
    if(viewWidth < 750) {
      baseHeight = parseInt(window.innerHeight * 0.85);
    }

    this.$container.css('height', baseHeight);

    let viewHeight = parseInt($('.Main').offset()['top']);
    let viewRatio = viewWidth / viewHeight;
    let videoRatio = 16 / 9;
    let videoTop = 0;
    let videoLeft = 0;

    if(viewRatio < videoRatio) {
      this.videoHeight = viewHeight;
      this.videoWidth = this.videoHeight * videoRatio;
      videoTop = 0;
      videoLeft = -parseInt((this.videoWidth - viewWidth) / 2);
    } else {
      this.videoWidth = viewWidth;
      this.videoHeight = this.videoWidth / videoRatio;
      videoLeft = 0;
      videoTop = -parseInt((this.videoHeight - viewHeight) / 2);
    }

    this.$video.css({
      'width': this.videoWidth,
      'height': this.videoHeight,
      'top': videoTop,
      'left': videoLeft
    });
    */
  }
}

export default Hero;
